// XLTooltip - Sprint 44 XL.
// Tooltip accesible con delay corto, posicionamiento simple y dark-mode
// automatico via tokens. Si el usuario usa navegacion por teclado, se
// muestra en focus. Cierra en blur/mouseleave/Escape.
import { useEffect, useRef, useState } from 'react';
import { ensureKeyframes, injectCSS } from '../../design/motion';

const CSS_ID = 'xl-tooltip-css';
const CSS = `
.xl-tt { position: relative; display: inline-flex }
.xl-tt__bubble {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background: var(--xl-color-text);
  color: var(--xl-color-text-inverse);
  font-family: var(--xl-font-sans);
  font-size: 12px;
  line-height: 1.4;
  padding: 6px 10px;
  border-radius: var(--xl-radius-sm);
  box-shadow: var(--xl-shadow-md);
  white-space: nowrap;
  pointer-events: none;
  z-index: 1100;
}
.xl-tt__bubble--top    { bottom: calc(100% + 6px) }
.xl-tt__bubble--bottom { top: calc(100% + 6px) }
`;

export default function XLTooltip({
  label,
  children,
  placement = 'top',
  delay = 200,
}) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  const [open, setOpen] = useState(false);
  const timer = useRef(null);

  const show = () => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setOpen(true), delay);
  };
  const hide = () => {
    if (timer.current) clearTimeout(timer.current);
    setOpen(false);
  };

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') hide(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  if (!label) return children;
  return (
    <span
      className="xl-tt"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      {children}
      {open && (
        <span
          role="tooltip"
          className={
            'xl-tt__bubble xl-tt__bubble--' + placement
            + ' xl-motion-fade-in'
          }
        >
          {label}
        </span>
      )}
    </span>
  );
}
